import React, {useEffect, useState } from "react";
import { getAllLeaveTracker } from "../../utils/helper";
import Loader from "../../utils/Loader";

export default function LeaveTracker() {
    const [employees, setEmployees] = useState(null);
    
    useEffect(() => {
        getAllLeaveTracker()
            .then((res) => { 
                setEmployees(res.data.data);  
            })
            .catch((err) => { 
                console.log(err.response)
            });
    }, []);

    return (
        <>            
            <h1 className="dash-title">Leave Tracker</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Leave Tracker</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {employees && employees ? 
                                    <div className="table-responsive">
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Staff Name</th><th>Staff Team</th><th>Annual Leave Days</th><th>Days Taken</th><th>Days Remaining</th></tr></thead>
                                            <tbody>
                                                {employees && employees.map((staff, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{staff.first_name && staff.first_name} {staff.last_name && staff.last_name}</td>
                                                        <td>{staff.team && staff.team} </td>
                                                        <td>{staff.totalDays && staff.totalDays} </td>
                                                        <td>{staff.daysTaken && staff.daysTaken} </td>
                                                        <td><span 
                                                            className={staff.totalDays === staff.daysLeft ? `badge badge-success` : `badge badge-warning`}
                                                        >{staff.daysLeft && staff.daysLeft}</span></td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                </div> : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
